import React from "react";


const AppPoliccy= () => {
  return (
    <div className="privacy-container">
      <div className="privacy-header">
        {/* <h1>[YOUR APP NAME]</h1> */}
        <h2>Privacy Policy</h2>

<p> <b>  Bhumu Company Mobile Application </b></p>
<p> Effective Date: April 11, 2025</p>
<p> Last Updated: April 11, 2025     </p>

        
        {/* <p><strong>Effective Date:</strong> [DD Month YYYY]</p>
        <p><strong>Last Updated:</strong> [DD Month YYYY]</p> */}
      </div>

      <div className="privacy-section">
        <h3> 1. Introduction</h3>
        <p>
       This Privacy Policy governs the collection, use, and protection of personal information by Bhumu Company through its mobile application ("the App"). The App enables users to book home services including bike servicing, AC repair, and pet grooming.
        </p>
        <p>
          By using the App, you acknowledge that you have read and understood this Privacy Policy. Your consent to data collection is obtained explicitly within the App before any personal data is processed. You may deny consent, though doing so may limit access to certain features.

        </p>
      </div>






      <div className="privacy-section">
        <h3>2. User Consent</h3>
        <p>Before collecting any personal data, the App presents a clear consent screen that:</p>
        <ul>
<li> Explains what data is collected and why</li>
<li> Allows you to grant or deny consent</li>
<li> Informs you that denying consent may restrict access to features such as service booking, provider assignment, and location-based availability</li>
<li> Can be updated or withdrawn at any time through the App's Settings</li>


        </ul>
<p>No personal data is collected, stored, or processed until the user provides explicit consent.</p>
      </div>





      <div className="privacy-section">
        <h3> 3. Data We Collect, When, and Why </h3>
      
      <p>We collect only the data strictly necessary to provide our home services. The following table describes what we collect, when we collect it, and the specific purpose for each data type.</p>
      </div>






      
      <div className="privacy-section">
        <h3> 3a. Full Name</h3>

<p> When collected: During account registration. </p>
<p> Why collected: To identify the account holder, personalize the user experience, and communicate service updates </p>

      
      </div>









      
      <div className="privacy-section">
        <h3> 3b. Phone Number </h3>

<p> When collected: During OTP-based account registration and login. </p>

<p>Why collected: To verify user identity via One-Time Password (OTP) authentication, and to contact the user regarding booking confirmations, service updates, and support.</p>

      
      </div>


     
      <div className="privacy-section">

  <h3>3c. Email Address </h3>



 <p> When collected: Optionally during account registration. </p>
   <p> Why collected: To send booking receipts, service summaries, and account-related notifications. </p>






      </div>


      <div className="privacy-section">



<h3>  3d. Device Location (Foreground Only) </h3>



<p>  When collected: Only while the App is actively open and in use (foreground).</p>
<p>  Why collected: To determine which services are available in your area and to assign the nearest qualified service professional to your booking.</p>
<p>  Background location: We do NOT collect location data when the App is closed or running in the background. Location access is automatically terminated when the App leaves the foreground.</p>
<p>  Location permission: The App requests location access only when needed. You may deny location permission via your device settings. If denied, service availability lookup and provider assignment will not function. </p>


</div>



      <div className="privacy-section">


 <h3> 4. Firebase Analytics </h3>


<p>The App uses Google Firebase Analytics to understand how users interact with the App, identify technical issues, and improve overall performance and usability.
Firebase Analytics collects the following usage data automatically when enabled: </p>
<ul>
<li>	Screen views and navigation patterns</li>
<li>	App session duration and frequency</li>
<li>	Device model and operating system version</li>
<li>	General crash and error reports </li>
</ul>

<p> Consent requirement: Firebase Analytics is disabled by default and is only enabled after the user grants explicit consent on the consent screen at app launch.
Opt-out: You may disable Firebase Analytics at any time through the App's Settings. Disabling analytics does not affect core service functionality.
Firebase Analytics operates under Google's Privacy Policy, available at https://policies.google.com/privacy </p>



</div>



      <div className="privacy-section">


 <h3> 5. How We Share Your Data </h3>

<p> We do not sell, rent, trade, or license your personal data to any third party for commercial purposes.  </p>
 <p>  Your data is shared only in the following limited circumstances: </p>


</div>






    <div className="privacy-section">


      <h3>5a. Service Professionals</h3>

<p> Your name, phone number, and approximate location are shared with the assigned service professional solely for the purpose of completing your booked service. Service professionals are contractually prohibited from using your data for any other purpose.</p>




    </div>









    <div className="privacy-section">


    <h3> 5b. Legal Obligations </h3>
 <p> We may disclose your personal data if required to do so by applicable law, court order, government authority, or to protect the rights, property, or safety of Bhumu Company, its users, or the public.  </p>


</div>




     <div className="privacy-section">
 
<h3> 5c. Firebase / Google </h3> 
 
 <p> Usage analytics data is processed by Google Firebase as described in Section 4. This sharing occurs only after user consent and is governed by Google's data processing terms. </p> 
 <p> We do not display advertisements and we do not share your data with advertising networks or data brokers. </p>

</div>


     <div className="privacy-section">
 
<h3> 6. Your Rights and Choices </h3>
 <p> You have the following rights with respect to your personal data: </p>

</div>


      <div className="privacy-section">
 <h3>6a. Access and Correction</h3>
 <p> You may review and update your name, phone number, and email address at any time through the Account Settings section of the App. </p>
</div>


<div className="privacy-section">

<h3> 6b. Account and Data Deletion </h3>
 <p> You may request deletion of your account and all associated personal data by submitting a request to info@bhumucompany.com or using the Delete Account option in App Settings. We will process your deletion request within 30 days. Booking history required for legal compliance may be retained for up to 90 days before permanent deletion.</p>

</div>



<div className="privacy-section">

<h3> 6c. Withdraw Consent </h3>
 <p> You may withdraw consent for data collection or analytics at any time through the App's Privacy Settings. Withdrawal of consent will stop all future data collection, but will not affect the lawfulness of processing carried out before withdrawal.</p>
</div>

<div className="privacy-section">
<h3> 6d. Location Permission </h3>
 <p> You may revoke location access at any time through your device's system settings. The App does not request permanent or background location access.</p>
</div>



<div className="privacy-section">

<h3> 7. Data Retention </h3>
 <p> We retain personal data only for as long as necessary to deliver our services and comply with legal obligations. The following retention periods apply: </p>
 <p> •	Account data (name, phone, email): Retained for the duration of the active account. Deleted within 30 days of account deletion request. </p>
 <p> •	Booking history: Retained for 90 days after service completion for dispute resolution and legal compliance, then permanently deleted. </p>
 <p> •	Location data: Not stored persistently. Location is used in real time during active sessions only and is not logged or retained after the session ends. </p>
 <p> •	Analytics data: Retained by Google Firebase as per their data retention policy. You may opt out at any time. </p>
</div>

<div className="privacy-section">

<h3> 8. Data Security </h3>
 <p> We implement the following security measures to protect your personal information: </p>
 <p> •	Encrypted data transmission using HTTPS/TLS for all communications between the App and our servers </p>
 <p> •	Firebase Authentication for secure OTP-based login, managed by Google </p>
 <p> •	Access controls that restrict user data to authorized personnel only </p>
 <p> •	Regular review of our data collection and security practices </p>



<p> While we take reasonable technical precautions to protect your data, no method of electronic transmission or storage is completely secure. We cannot guarantee absolute security of your personal information. </p>


</div>

<div className="privacy-section">

<h3> 9. Third-Party Services </h3>
 <p> The App integrates the following third-party service: </p>
 <p> Google Firebase (Authentication and Analytics): Used for OTP-based login and usage analytics. Operated by Google LLC under its own Privacy Policy and Terms of Service. For details, visit https://firebase.google.com/support/privacy </p>
 <p> We do not integrate advertising SDKs, third-party data brokers, or social media tracking tools. </p>
</div>




<div className="privacy-section">
<h3> 10. Children's Privacy </h3>
 <p> The App is not intended for use by individuals under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that personal data has been collected from a child under 13 without verifiable parental consent, we will delete that data within 30 days. If you believe a child has provided us with personal information, please contact us at info@bhumucompany.com. </p>
</div>

<div className="privacy-section">
<h3> 11. Changes to This Privacy Policy </h3>
 <p> We may revise this Privacy Policy periodically to reflect changes in our practices, legal requirements, or service offerings. When material changes are made, we will notify you through an in-app notification or by email prior to the change becoming effective. Continued use of the App after the effective date of any revision constitutes your acceptance of the updated policy. </p>
</div>
<div className="privacy-section">
<h3> 12. Contact Us </h3>
 <p> If you have questions, concerns, or requests relating to this Privacy Policy or your personal data, please contact us at: </p>
 <p> Bhumu Company </p>
 <p> Email: info@bhumucompany.com </p>
 <p> We will respond to all privacy-related requests within 30 days. </p>
</div>







<div className="privacy-section">

 <h3> 13. Account Deletion Policy </h3>

<p>  Users can request deletion of their account and associated data directly from within the app.  </p>

<ul> 
     <li>  To delete your account:  </li>
     <li>  1. Open the app and log in </li>
     <li>  2. Go to Profile / Settings section </li>
     <li>  3. Tap on "Delete Account" </li>
     <li>  4. Confirm the deletion request   </li>


      </ul>

<p> Once the request is submitted, all personal data associated with the account will be permanently deleted within 30 days. </p>

<p> If you face any issues, you can contact us at: </p>
<p> Email: info@bhumucompany.com </p>


</div>


<div className="privacy-section">
This Privacy Policy is effective as of April 11, 2025 and applies to all users of the Bhumu Company App.
</div>


    </div>
  );
};

export default AppPoliccy;

// export default AppPoliccy